<template>
    <div>
        <v-fade-transition leave-absolute>
            <div v-show="!isDone">
                <slot name="on-going" />
            </div>
        </v-fade-transition>
        <v-fade-transition leave-absolute>
            <div v-show="isDone">
                <slot name="finished" />
            </div>
        </v-fade-transition>
    </div>
</template>

<script>
import dayjs from "dayjs";
export default {
    props: ["work"],
    data: () => ({
        isDone: false,
        interval: null,
    }),
    computed: {
        endsAt() {
            return this.work?.duration_auction?.endsAt || this.work?.program?.duration?.endsAt;
        },
    },
    mounted() {
        this.interval = setInterval(this.setRemained, 1000);
    },
    destroyed() {
        if (this.interval !== null) {
            clearInterval(this.interval);
            this.interval = null;
        }
    },
    methods: {
        setRemained() {
            const now = dayjs();
            const endsAt = dayjs(this.endsAt);

            const isBefore = endsAt.isBefore(now);
            if (isBefore && !this.isDone) this.isDone = true;
        },
    },
};
</script>

<style></style>
